import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';
import { Endpoints, GenericError, UserId } from '../../constants';
import httpService from '../../services/http-service';
import { Notify } from '../../sharedcomponents/Alert/Notify';
import Loader from '../../components/Loader';
import smartHttp from '../../helpers/smartHttp';
const NewLocationCellRenderer = (params) => {
  const { locationOptions, onLocationChange } = params;
  const { data } = params;
  return (
    <select
      className={`location-mapping-select form-select form-select-sm${data?.hasError ? ' is-invalid' : ''}`}
      value={data?.newLocationId || ''}
      onChange={(e) => onLocationChange(data?.id, e.target.value)}
    >
      <option value="">-- Select Location --</option>
      {(locationOptions || []).map((loc) => (
        <option
          key={loc.officeLocationId}
          value={loc.officeLocationId}
          title={String(loc.officeLocationName || '').trim()}
        >
          {String(loc.officeLocationName || '').trim().length > 50
            ? `${String(loc.officeLocationName || '').trim().slice(0, 50)}...`
            : String(loc.officeLocationName || '').trim()}
        </option>
      ))}
    </select>
  );
};

const LocationMapping = ({ show, setShow, oldLocations, contractNumbers }) => {
  const [loading, setLoading] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [rowData, setRowData] = useState([]);
  const gridApiRef = useRef();

  useEffect(() => {
    if (show && oldLocations?.length > 0) {
      setRowData(
        oldLocations.map((loc, i) => ({
          ...loc,
          id: i,
          newLocationId: '',
          hasError: false,
        })),
      );
      
    } else {
      setRowData([]);
      setLocationOptions([]);
    }
  }, [show,oldLocations]);


  useEffect(() => {
    if(contractNumbers?.length>0){
      fetchLocations();
    }
  }, [contractNumbers]);

  const fetchLocations = async () => {
    if (!contractNumbers?.length) return;
    setLoading(true);
    try {
      const contractFilter = contractNumbers.map((c) => `"${c}"`).join(',');
      const response = await smartHttp.get(Endpoints.locationApi, {
        filter: `contractNumber in (${contractFilter})`,
        pageSize: 5000,
        Field: 'officeLocationId,officeLocationName,contractNumber',
      });
      setLocationOptions(response?.data?.results || []);
    } catch {
      Notify({
        alert: true,
        type: 'error',
        title: GenericError.somethingWentWrong,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleLocationChange = useCallback((rowId, newLocationId) => {
    setRowData((prev) =>
      prev.map((r) =>
        r.id === rowId ? { ...r, newLocationId, hasError: false } : r,
      ),
    );
  }, []);
const afterLocationUpdate = () => {
   Notify({
      alert: true,
      type: 'success',
      title: 'Location mapping updated successfully',
      confirmBtnText: 'OK',
    });
setShow(false);
};
const saveLocationMapping = async (mappingData) => {
  try {
        setLoading(true);
    const resp = await smartHttp.putRapid(Endpoints.updateLocationMappingApi, mappingData);
        if (resp?.data?.success === true || resp?.data?.data[0]?.p_error === 0) {
          afterLocationUpdate();
        }
      } catch (error) {
        Notify({
          alert: true,
          type: 'error',
          title: GenericError.somethingWentWrong,
        });
      }
      finally{
        setLoading(false);
      }
};

  const handleUpdate = () => {
    let hasAnyError = false;
    const updatedRows = rowData.map((row) => {
      if (!row.newLocationId) {
        hasAnyError = true;
        return { ...row, hasError: true };
      }
      return row;
    });
    if (hasAnyError) {
      setRowData(updatedRows);
      return;
    }
    // TODO: call update API with rowData mapping
    let mappingData = {
      p_location_details : updatedRows.map((row) => ({
      old_officelocationid: row.officelocationid,
      new_officelocationid: row.newLocationId,
      contractnumber: row.contractnumber,
    })),
p_user :UserId ,
p_exhibit_flow : 1
  };
    saveLocationMapping(mappingData);
   
  };

  const columns = useMemo(
    () => [
      {
        headerName: 'Removed Location',
        field: 'officelocationname',
        tooltipField: 'officelocationname',
        flex: 1,
      },
      {
        headerName: 'New Location',
        field: 'newlocationid',
        flex: 1.5,
        cellRenderer: NewLocationCellRenderer,
        cellRendererParams: {
          locationOptions,
          onLocationChange: handleLocationChange,
        },
      },
    ],
    [locationOptions, handleLocationChange],
  );

  const defaultColDef = useMemo(
    () => ({ sortable: false, resizable: true, menuTabs: [] }),
    [],
  );

  const loaderStyle = {
    width: '100%',
    height: '100%',
    background: '#cdcecf6e',
    display: 'flex',
    position: 'absolute',
    zIndex: '1100',
    justifyContent: 'center',
    alignItems: 'center',
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      size='lg'
      dialogClassName="modal-size-md"
    >
      {loading && <Loader type="scaleLoader" cssClass={loaderStyle} />}
      <Modal.Header>
        <span className="user-form-title">Location Mapping</span>
      </Modal.Header>
      <Modal.Body>
        <div className="ag-theme-alpine" style={{ height: '400px' }}>
          <AgGridReact
            onGridReady={(params) => {
              gridApiRef.current = params.api;
            }}
            rowData={rowData}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            rowModelType="clientSide"
            enableBrowserTooltips
            suppressRowClickSelection
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-end">
        <Button
          variant="dark"
          className="btn-opacity alert-btn"
          onClick={handleUpdate}
        >
          UPDATE
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LocationMapping;
